module.exports = __webpack_public_path__ + "static/media/nissan-navara.67c3e864.webp";